import { render, staticRenderFns } from "./loginuserEtc.vue?vue&type=template&id=5da5f5c4&scoped=true&"
import script from "./loginuserEtc.vue?vue&type=script&lang=js&"
export * from "./loginuserEtc.vue?vue&type=script&lang=js&"
import style0 from "./loginuserEtc.vue?vue&type=style&index=0&id=5da5f5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5f5c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
